import { FC } from 'react';
import { Link } from 'react-router-dom';

import { Typography } from '@mui/material';
import { Dashboard } from '@src/main/modules/common/dashboard/domain/Dashboard';

import OpenSourceButton from '@src/main/ui/components/common/Dashboard/common/buttons/OpenSourceButton/OpenSourceButton';
import RefreshDate from '@src/main/ui/components/common/Dashboard/common/footer/RefreshDate/RefreshDate';
import Views from '@src/main/ui/components/common/Dashboard/common/footer/Views/Views';
import styles from './DashboardFooter.module.scss';

interface Props {
  dashboard?: Dashboard;
}

const defaultProps = { dashboard: undefined };

const getOpenSourceUrl = (dashboard: Dashboard) => {
  if (dashboard.artifactType === 'PowerApp') {
    return `https://apps.powerapps.com/play/${dashboard.artifactId}`;
  }
  if (dashboard.artifactType === 'LookerStudio') {
    return `https://lookerstudio.google.com/reporting/${dashboard.artifactId}`;
  }
  return `https://app.powerbi.com/groups/${dashboard.workspaceId}/reports/${dashboard.artifactId}`;
};

const DashboardFooter: FC<Props> = ({ dashboard }) => (
  <>
    {dashboard && (
      <div className={styles.content}>
        <div className={styles.content__info}>
          <div className={styles.content__info__refreshAndViews}>
            <RefreshDate refreshDate={dashboard.refreshDate} variant="medium" />
            <Views views={dashboard.views} variant="medium" />
          </div>
          <div>
            <Link to={getOpenSourceUrl(dashboard)} target="_blank">
              <OpenSourceButton fontSize="30px" />
            </Link>
          </div>
        </div>
        <div className={styles.content__description}>
          <Typography variant="h6" color="text.secondary">
            Description
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ paddingTop: 1 }}>
            {dashboard.description}
          </Typography>
        </div>
      </div>
    )}
  </>
);

DashboardFooter.defaultProps = defaultProps;

export default DashboardFooter;
